module.exports = "<div id=\"tb-error-page-root\">\n    <div uib-alert\n         ng-class=\"'success' | tbAlertType : true\">\n        {{errorPageCtrl.errorMessage}}\n    </div>\n\n    <button type=\"button\" class=\"btn btn-primary\" ng-click=\"errorPageCtrl.reloadApp()\">Reload App</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/views/error-page/ErrorPage.tpl.html
// module id = 2Y9f
// module chunks = 1